import { useEffect, useId, useState, type RefObject } from 'react';

/** Curves follow the actual island centres at every breakpoint, including long copy. */
export function RoadmapPath({
  roadmap,
  count,
}: {
  roadmap: RefObject<HTMLDivElement | null>;
  count: number;
}) {
  const gradient = useId();
  const [shape, setShape] = useState({ path: '', width: 1, height: 1 });
  useEffect(() => {
    const element = roadmap.current;
    if (!element) return;
    function measure() {
      if (!element) return;
      const bounds = element.getBoundingClientRect();
      const points = Array.from(
        element.querySelectorAll<HTMLElement>('[data-island-id]'),
        (node) => {
          const r = node.getBoundingClientRect();
          return { x: r.left + r.width / 2 - bounds.left, y: r.top + r.height / 2 - bounds.top };
        },
      );
      const path = points
        .map((point, index) => {
          if (index === 0) return `M ${point.x} ${point.y}`;
          const previous = points[index - 1]!;
          const middle = (previous.y + point.y) / 2;
          return `C ${previous.x} ${middle}, ${point.x} ${middle}, ${point.x} ${point.y}`;
        })
        .join(' ');
      setShape({ path, width: bounds.width || 1, height: bounds.height || 1 });
    }
    measure();
    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [roadmap, count]);
  return (
    <svg
      className="milestone-route-line"
      viewBox={`0 0 ${shape.width} ${shape.height}`}
      preserveAspectRatio="none"
      aria-hidden
    >
      <defs>
        <linearGradient id={gradient} x1="0" y1="0" x2="0" y2="1">
          <stop stopColor="#e3c17e" stopOpacity=".55" />
          <stop offset="1" stopColor="#847458" stopOpacity=".16" />
        </linearGradient>
      </defs>
      <path
        d={shape.path}
        fill="none"
        stroke={`url(#${gradient})`}
        strokeWidth="2.5"
        strokeDasharray="5 11"
        strokeLinecap="round"
      />
    </svg>
  );
}
